export default __webpack_public_path__ + "static/media/duplicate-icon.365996e1.svg";